import { display } from '@mui/system';
import React from 'react';

export default function TopAndBottom({ components, style, colstyles, ...props }) {

    const TopComponent = components[0]
    const BottomComponent = components[1]
    
    let component_style = { ...styles.container, ...style }



    return (
        <div className='top-and-bottom' style={component_style} {...props}>
            <TopComponent />
            <BottomComponent />
        </div>
    )
}

const styles = {
    container: {
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexFlow: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '15px',
    }
}
